angular.module('gym.invoices', []).config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('gym.invoices', {
    url: '/invoices?contactId&status&dashletDates',
    template: require('templates/gyms/invoices/index.html.slim'),
    controller: 'InvoicesCtrl',
    resolve: {
      familyContact: ["$stateParams", "Restangular", function($stateParams, Restangular) {
        if ($stateParams.contactId) {
          return Restangular.one('gyms', $stateParams.gymId).one('contacts', $stateParams.contactId).get();
        }
      }]
    }
  });
}]);
